import { useQueryClient } from "@tanstack/react-query";
import * as React from "react";
import { HandleThunkActionCreator } from "react-redux";
import { Location } from "react-router";
import { dispatchSwitchOperator } from "../../../actions/common/session/index";
import OperatorInterface from "../../../interfaces/OperatorInterface";
import LinkList from "../../atoms/LinkList";

interface DispatchProps {
  onSwitchOperator: HandleThunkActionCreator<typeof dispatchSwitchOperator>;
}
interface StateProps {
  currentOperator: OperatorInterface;
  operators: OperatorInterface[];
}

interface Props extends DispatchProps, StateProps {
  location: Location;
}

const SessionsEdit = (props: Props): React.ReactElement<any> => {
  return (
    <LinkList>
      {props.operators.map((operator) => (
        <Operator
          key={`operator-${operator.id}`}
          {...props}
          operator={operator}
        />
      ))}
    </LinkList>
  );
};

const Operator = ({
  operator,
  ...props
}: Props & { operator: OperatorInterface }) => {
  const queryClient = useQueryClient();

  if (!props.currentOperator) {
    return null;
  }

  const handleClickOperator =
    (props: Props, operator: OperatorInterface) => () => {
      props.onSwitchOperator(operator, {
        withRedirect: true,
        onSuccess: () => {
          // 変更前のオペレーターのキャッシュが残らないようにリセットする
          queryClient.resetQueries();
        },
      });
    };

  return (
    <LinkList.Item
      key={`SessionsEdit-${operator.id}`}
      isActive={props.currentOperator.id === operator.id}
      isDisabled={props.currentOperator.id === operator.id}
      iconName="icon-account"
      theme="gray"
      onClick={handleClickOperator(props, operator)}
      to={props.location}
    >
      {operator.fullName}
    </LinkList.Item>
  );
};

export default SessionsEdit;
